module.exports = __webpack_public_path__ + "media/img/corporate/second-line-mobile-f761529155fda35c6c6cbc6457cc3937.svg";